import React, { useState } from "react";
import styles from "../HomeFaqs/homeFaqs.module.css"
import Animations from "../Animations/animations";

const HomeFaqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const faqData = [
    {
      no: "01.",
      question: "How do I get started?",
      answer:
        "You don’t need much. All you need is a workable concept and your requirements to bring that concept to life. And a bit of capital as well, obviously. Once we evaluate your concept, we’ll assign it to our developers and they’ll take it from there.",
    },
    {
      no: "02.",
      question: "Do you provide marketing services?",
      answer:
        "Since we provide developers and designers only, we don’t focus on marketing. We think the best practice is for us to focus on building your concept into a full-fledged product while you handle marketing either by yourself or a third-party marketing agency.",
    },
    {
      no: "03.",
      question: "What technologies can you work with?",
      answer:
        "We don’t like to limit our client’s vision by sticking to a rigid tech stack. Instead, we assess the unique requirements and objectives of each project and then carefully select the most suitable tools and technologies. Whether it’s web development, mobile app development, or software development, our team is equipped with the expertise to utilize a wide range of technologies to bring your vision to life.",
    },
    {
      no: "04.",
      question: "How do you assign developers per project?",
      answer:
        "Our developer assignment process begins with understanding your project requirements and goals. We then carefully select developers from our pool based on their expertise and experience relevant to your project. Once selected, our developers work closely with you to ensure that they understand your vision and deliver high-quality results.",
    },
    {
      no: "05.",
      question: "What sets your company apart from other development service providers?",
      answer:
        "At NinjasCode stands out due to our commitment to delivering high-quality results tailored to each client’s unique needs. We prioritize transparency, communication, and collaboration throughout the development process. With a focus on the latest technologies and industry best practices, we ensure that your project stays ahead of the curve and exceeds your expectations. Additionally, our open-source approach and customer testimonials speak to the trust and satisfaction our clients have in our services.",
    },
  ];

  return (
    <section className={styles.faqsSec}>
      <div className={styles.container}>
      <Animations animationType="fadeInUp" threshold={0.2}>
        <h2>
          Frequently Asked Questions
        </h2>
        </Animations>
        <Animations animationType="fadeInUp" threshold={0.2}>
        <div className={styles.accordionContainer}>
          {faqData.map((faq, index) => (
            <div
              key={index}
              className={`${styles.accordionItem} ${
                activeIndex === index ? styles.active : ""
              }`}
            >
              <div
                className={styles.accordionTitle}
                onClick={() => toggleAccordion(index)}
              >
                <div className={styles.faqNo}>{faq.no}</div>
                <div className={styles.faqQuestion}>{faq.question}</div>
                <div
                  className={`${styles.faqIcon} ${
                    activeIndex === index ? styles.minusIcon : styles.plusIcon
                  }`}
                >
                  {activeIndex === index ? "-" : "+"}
                </div>
              </div>
              <div
                className={styles.accordionContent}
                style={{
                  display: activeIndex === index ? "block" : "none",
                }}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
        </Animations>
      </div>
    </section>
  );
};

export default HomeFaqs;
